import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyFeatureLocked = lazy(() => import('./svg-components/feature-locked'));

const FeatureLocked = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyFeatureLocked {...rest} />
  </Suspense>
);

export default FeatureLocked;
